import styles from "./styles.module.scss"
import bridge from "@vkontakte/vk-bridge"
import { Button, Div, Group, Link, Panel, Spacing } from "@vkontakte/vkui"
import { useUnit } from "effector-react"
import { memo, useCallback } from "react"
import { AppPanels, AppPanelsT } from "src/app/providers/RouteProvider/lib/routeConfig"
import { setActivePanel } from "src/entity/ActivePanel"
import textLogo from "src/shared/assets/images/head.png"
import mainLogo from "src/shared/assets/images/logo2025.png"
// import { CharactersCover } from 'src/shared/ui/charactersCover/CharactersCover';
import { Cover } from "src/shared/ui/cover"
import { SuperBtn } from "src/shared/ui/superBtn"

interface IIntroPanelProps {
  id: AppPanelsT
}

export const IntroPanel = memo(({ id }: IIntroPanelProps) => {
  // @ts-ignore
  bridge.send("VKWebAppSendCustomEvent", {
    event: "launch",
    screen: "intro",
  })

  const [onSetActivePanel] = useUnit([setActivePanel])

  const onRulesButtonClick = useCallback(() => {
    onSetActivePanel(AppPanels.RULES)
  }, [onSetActivePanel])

  const onStartButtonClick = useCallback(() => {
    onSetActivePanel(AppPanels.VOITING)
    // @ts-ignore
    bridge.send("VKWebAppSendCustomEvent", {
      event: "vote_click",
      screen: "intro",
    })
  }, [onSetActivePanel])

  const onPlayButtonClick = useCallback(() => {
    onSetActivePanel(AppPanels.PUZZLE_GAME)
    // @ts-ignore
    bridge.send("VKWebAppSendCustomEvent", {
      event: "play_click",
      screen: "intro",
    })
  }, [onSetActivePanel])

  // const onSetStatusButtonClick = useCallback(() => {
  //   onSetActivePanel(AppPanels.FINAL);
  //   // @ts-ignore
  //   bridge.send('VKWebAppSendCustomEvent', {
  //     event: 'set_emoji_status_click',
  //     screen: 'intro'
  //   });
  // }, [onSetActivePanel]);

  return (
    <Panel id={id}>
      <Group>
        <Div className={styles.main_heroes_logo}>
          <img src={mainLogo} alt="Главные Герои 2022" />
        </Div>

        {/* <Div className={styles.textLogo}>
          <img src={textLogo} alt="text" />
        </Div> */}
        <Spacing size={18} />

        <Div className={styles.info}>
          <Spacing size={18} />
          {/* <SuperBtn size="l" onClick={onStartButtonClick} text="Голосование" color="2" /> */}

          <Button size="m" color="#ff008e" className="button-main  button-main--pink" onClick={onStartButtonClick}>
            Голосование
          </Button>

          <Spacing size={24} />

          <Button size="m" className="button-main button-main--purple" onClick={onPlayButtonClick}>
            Играть
          </Button>

          {/* <SuperBtn size="m" text="Играть" color="3" onClick={onPlayButtonClick} /> */}

          {/* <Spacing size={18} /> */}

          {/* <SuperBtn
            size='s'
            text='Установить эмодзи-статус'
            color='1'
            onClick={onSetStatusButtonClick}
          /> */}

          <Spacing size={18} />
          <Link onClick={onRulesButtonClick} className={styles.link}>
            Правила проведения Национальной детской премии
            <br />
            «Главные Герои 2025»
          </Link>
        </Div>
      </Group>
      <Cover />
      {/* <CharactersCover /> */}
    </Panel>
  )
})
